"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var JSZip = require("jszip");
function readArchive(fileContent) {
    return new JSZip().loadAsync(fileContent);
}
exports.readArchive = readArchive;



//////////////////
// WEBPACK FOOTER
// ./node_modules/file2html-archive-tools/lib/index.js
// module id = 657
// module chunks = 0